<template>
    <div class="link-pagination" :class="classes">
        <div class="link-pagination-left">
            <link-select
                :size="size"
                suffix-icon="link-icon-down"
                :width="width"
                @select="handleSelect"
                :value="currentPageSize"
                hide-clear-icon
                class="link-pagination-select"
                :data="sizeOption"
                :display-format="sizeOptionDisplayFormat">
                <template slot-scope="{item,index,checked}">
                    <span>{{item}}条/页</span>
                </template>
            </link-select>
            <div class="link-pagination-operate-wrapper">
                <link-icon icon="link-icon-left" @click.stop="handleClickPrevNumIcon"/>
                <div v-if="showPageNum">
                    <div class="link-pagination-operate-num" @click.stop="handleClickFirstNum()" v-show="page-availablePage-1>0">1</div>
                    <link-icon icon="icon-more" v-show="page-availablePage-2>0"/>
                    <div v-for="(item,index) in nums" :key="index"
                         class="link-pagination-operate-num"
                         :class="{'link-pagination-operate-num-active':item === currentPage}"
                         @click.stop="handleClickNum(item)">
                        {{item}}
                    </div>
                    <link-icon icon="icon-more" v-show="showLastPageIcon"/>
                    <div class="link-pagination-operate-num" @click.stop="handleClickLastNum()" v-show="showLastPage">{{totalPage}}</div>
                </div>
                <link-icon icon="link-icon-right" @click.stop="handleClickNextNumIcon"/>
                <!--<link-icon icon="icon-refresh" @click.stop="handleClickRefresh"/>-->
            </div>
            <div class="link-pagination-input">
                <span>前往&nbsp;</span>
                <link-input-number :showIcon="false" placeholder="页码" hideClearIcon :width="50" :value="page" @enter.stop="handleJumpPage" :min="1" :regexp="/[^0-9]/g"/>
                <span>&nbsp;页</span>
            </div>
        </div>

    </div>
</template>

<script>

    import LinkInput from '../input/link-input';

    export default {
        name: 'link-pagination',
        components: {LinkInput},
        props: {
            showPageNum: {type: Boolean, default: true},
            width: {type: Number, default: 80},
            size: {type: String, default: 'default'},
            page: {default: 1},
            pageSize: {type: Number | String, default: '10'},
            totalSize: {type: Number},
            sizeOption: {type: Array},
            availablePage: {type: Number, default: 3}
        },
        watch: {
            page(val) {
                if (this.currentPage !== val) this.currentPage = val - 0;
            },
            currentPage(val) {
                // console.log('currentPage', val)
                this.$emit('update:page', val);
            },
            pageSize(val) {
                if (this.currentPageSize !== val) this.currentPageSize = val;
            }
        },
        data() {
            return {
                currentPage: this.page - 0,
                currentPageSize: this.pageSize,
                begin: null,
                end: null,
                targetPage: 1,
                showLastPage: false,
                showLastPageIcon: false
            };
        },
        computed: {
            classes() {
                return [`link-pagination-${this.size}`];
            },
            totalPage() {
                return Math.ceil(this.totalSize / this.pageSize);
            },
            nums() {
                if (!this.totalSize) return [];
                const ret = [];

                let begin = this.page - 0 - this.availablePage;
                let end = this.page - 0 + this.availablePage;
                if (begin < 1) {
                    end += 1 - begin;
                    begin = 1;
                }
                if (end < this.totalPage) {
                    this.showLastPage = true;
                } else {
                    end = this.totalPage;
                    this.showLastPage = false;
                }
                this.showLastPageIcon = end !== this.totalPage - 1 && this.showLastPage;
                this.begin = begin;
                this.end = end;

                while (begin <= end) {
                    ret.push(begin);
                    begin++;
                }

                return ret;
            }
        },
        methods: {
            handleSelect(val) {
                this.currentPageSize = val;
                this.$emit('size-change', val);
                this.$emit('update:pageSize', val);
                this.page = 1;
                this.$emit('update:page', this.page);
                this.$emit('refresh');
            },
            handleClickNum(item) {
                this.currentPage = item;
                this.$nextTick(() => this.$emit('load'));
            },
            handleClickPrevNumIcon() {
                if (this.currentPage - 1 < 1) return;
                this.currentPage--;
                this.$nextTick(() => this.$emit('load'));
            },
            handleClickNextNumIcon() {
                if (this.currentPage + 1 > this.totalPage) return;
                else this.currentPage++;
                this.$nextTick(() => this.$emit('load'));
            },
            handleClickFirstNum() {
                this.currentPage = 1;
                this.$nextTick(() => this.$emit('load'));
            },
            handleClickLastNum() {
                this.currentPage = this.totalPage;
                this.$nextTick(() => this.$emit('load'));
            },
            handleClickRefresh() {
                this.$emit('refresh');
            },
            async handleJumpPage(e) {
                this.$emit('jump', e.target.value)
            },
            sizeOptionDisplayFormat(data, val) {
                if (data == null || val == null) return null;
                for (let i = 0; i < data.length; i++) {
                    const item = data[i];
                    if (item.value === val) return `${val}条/页`;
                }
                return null;
            }
        }
    };
</script>

<style lang="scss">
    @include themeify {
        .link-pagination {
            display: inline-flex;
            align-items: center;
            justify-content: space-between;
            color: $color-normal-content;
            user-select: none;
            box-sizing: border-box;
            height: 28px;
            font-size: 12px;

            .link-pagination-input {
                display: inline-flex;
                align-items: center;

                input {
                    text-align: center;
                }
            }

            .link-pagination-operate-num {
                min-width: 32px;
                height: 32px;
                line-height: 32px;
                border-radius: 100px;
            }

            .link-pagination-left {
                display: flex;
                align-items: center;

                & > *:not(:last-child) {
                    margin-right: 36px;
                }
            }

            .link-pagination-operate-wrapper {
                display: inline-flex;
                align-items: center;
                /*margin: 0 36px;*/
                .link-icon, .link-pagination-operate-num {
                    cursor: pointer;
                    margin: 0 6px;
                    font-size: inherit;
                    color: $color-normal-input;
                }

                .link-pagination-operate-num {
                    display: inline-block;
                    text-align: center;

                    &.link-pagination-operate-num-active {
                        background-color: $color-primary;
                        color: white;
                    }
                }
            }
        }

    }
</style>
